import React from 'react';
import { getItemWebUrl } from '../../../../lib/helpers';

export default function Research({ reports }) {
    return (
        <section className="lp-research">
            <div className="lp-research__header">
                <h2>Intelligence that moves markets</h2>
                <p>
                    Our flagship venture investment reports are the most cited data source
                    across MENA, Africa, and beyond.
                </p>
            </div>

            <div className="row lp-research__cards">
                {reports.map((item, i) => {
                    const itemUrl = getItemWebUrl('research', item.id, item.code);
                    const category = item.category_data?.name;
                    return (
                        <div className="col-md-4 col-sm-12" key={i}>
                            <a className="lp-research-card" href={`/${itemUrl}`}>
                                <div className="lp-research-card__img-wrap">
                                    <img src={item.image_data.path} alt={item.name} />
                                    {item.displayPrice !== 'FREE' && (
                                        <span className="lp-research-card__badge">
                                            {item.displayPrice}
                                        </span>
                                    )}
                                </div>
                                <div className="lp-research-card__body">
                                    <h4>{item.name}</h4>
                                    <p>{item.short_description}</p>
                                    <div className="lp-research-card__meta">
                                        <span>{item.published_at}</span>
                                        {category && (
                                            <span className="lp-research-card__category">{category}</span>
                                        )}
                                    </div>
                                </div>
                            </a>
                        </div>
                    );
                })}
            </div>

            <div className="lp-research__footer">
                <a className="btn btn-main" href="/research">Browse All Research</a>
            </div>
        </section>
    );
}
